<template>
    <div :class="is_mobile_app ? '': 'wrapper'">
 <section class="row back_white mb-3 mx-md-3">
        <div class="col-12 d-flex justify-content-center" >
                <h3 class="static_title">{{$t("PRIVACYPOLICY")}}</h3>
        </div>

        <div class="col-12 mt-3" :class="isRTL ? 'rtl text-right' : ''">
        <p>
           {{$t("REFERRED_TO")}} 
        </p>
        </div>

        <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("WHAT_INFORMATION")}} ?</span>    
        <p class="mt-2">
           {{$t("WE_OFFER")}}
        </p>

        </div>

          <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("WHAT_INFORMATION_FOR")}}</span>    
        <p class="mt-2">
           {{$t("ANY_INFORMATION")}}
        </p>
        <ul>
            <li>{{$t("PERSONALIZE_ENHANCE")}}</li>
        <li>{{$t("IMPROVE_WEBSITE")}}</li>
        <li>{{$t("IMPROVE_CUSTOMER")}}</li>
        <li>{{$t("PROCESS_TRANSACTIONS")}}</li>
        <li>{{$t("ADMINISTER_CONTEST")}}</li>
        <li>{{$t("SEND_PERIODIC")}}</li>
    </ul>

    <p class="mt-3" style="color:red">{{$t("NOTE_UNSUBSRICBE")}}
    </p>

        </div>



        <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("ACCESSING_UPDATING")}}</span>    
        <p class="mt-2">
           {{$t("WHEN_YOU_USE_OUR_SERVICES")}}
        </p>

        </div>


        <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("DO_COOKIES")}}</span>    
        <p class="mt-2">
         {{$t("YES_COOKIES_SMALL")}}
        </p>

        </div>

     <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("DO_WE_DISCLOSE")}}</span>    
        <p class="mt-2">
         {{$t("WE_DO_NOT_SELL")}}
        </p>

        </div>

             <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("THIRD")}}</span>    
        <p class="mt-2">
         {{$t("OCCASIONALLY_DISCRETION")}}
        </p>

        </div>


                     <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("TERMS_AND_CONDITIONS")}}</span>    
        <p class="mt-2">
        {{$t("PLEASE_ALSO_VISIT")}} 
         <a href="https://www.wanasatime.com" style="color:#337ab7;">https://www.wanasatime.com</a>
        </p>

        </div>

           <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("YOUR_CONSENT")}}</span>    
        <p class="mt-2">
         {{$t("BY_USING")}}
        </p>

        </div>


           <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("DISCLAIMERS")}}</span>    
        <p class="mt-2">
      {{$t("WHENEVER_YOU_VOLUNTARILY")}}
        </p>

        </div>

               <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("CHANGES_PRIVACY")}}</span>    
        <p class="mt-2">
     {{$t("PLEASE_NOTE_PRIVACY")}}
        </p>

        </div>


         <div class="col-12 d-block mt-3" :class="isRTL ? 'rtl text-right' : ''">
            <span class="font-weight-bold" style="color:#ED5965;">{{$t("CONTACT_US")}}</span>    
        <p class="mt-2">
    {{$t("PROTECT_PRIVACY")}}
        </p>
        <p class="mt-5" :class="isRTL ? 'rtl text-right' : ''">
            {{$t("EMAIL")}}: <a href="mailto:hello@wanasatime.com" style="color:#337ab7;">hello@wanasatime.com</a><br>
            {{$t("PHONE")}}: +973 13633334
        </p>

        </div>

      </section>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {

    data(){
        return{
            is_mobile_app: 0
        
        };
    },
    watch: {
    
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(() => {
          if (!!is_mobile_app) {
            this.is_mobile_app = is_mobile_app;
          }
        });
      },
      immediate: true,
    },
  },
    computed:{
     ...mapGetters(['isRTL']),
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/privacy.vue